import React from 'react';
import PropTypes from 'prop-types';
import MaximizableView from '../../MaximizableView';
import Statistics from './statistics';

export default class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      style: 'small',
    };
    this.handleView = this.handleView.bind(this);
  }

  handleView() {
    const { style } = this.state;
    if (style === 'full') {
      this.setState({ style: 'small' });
    }
    if (style === 'small') {
      this.setState({ style: 'full' });
    }
  }

  render() {
    const {
      global, date, handleCountry, handleReset,
    } = this.state;
    const {
      countries, quality, period, searchValue,
    } = this.props;
    const { param } = this.state;

    let copyCountries = [...countries];

    if (searchValue !== '') {
      const search = searchValue;
      copyCountries = copyCountries.filter(
        (country) => country.Country.toLowerCase().includes(search.toLowerCase()),
      );
    }

    return (
      <MaximizableView>
        <Statistics
          quality={quality}
          period={period}
          param={param}
          countries={copyCountries}
          global={global}
          date={date}
          handleCountry={handleCountry}
          handleReset={handleReset}
        />
      </MaximizableView>
    );
  }
}

Table.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.shape({
    Country: PropTypes.string,
    length: PropTypes.number,
  })).isRequired,
  quality: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
};
